import styles from '../../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div
      id='libraryEmploymentFolderPreview'
      role='dialog'
      onKeyDown={(e) => e.stopPropagation()}
      className={styles.template_preview_container}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <p id='libraryEmploymentFolderPreviewText'>
        The Employment Folder gives small businesses the documents they need to stay compliant with
        Fair Work laws and avoid costly mistakes. It includes essential contracts, HR policies (like
        bullying, leave and termination), and legally required records that must be kept for at
        least seven years. Missing or mismanaging these documents can lead to penalties from $4,200
        to over $3 million.
      </p>
    </div>
  );
};

export default Preview;
